<template>
    <div class="home-footer">
        <div class="home-footer-box">
            <div class="footer-box-top">
                <div class="footer-top-left">
                    <div class="footer-top-left-one">
                        <div class="footer-hotline">
                            <img src="@/assets/images/index/icon_tel.png" alt="">
                        </div>
                        <div class="footer-hotline-text">24小时客服热线</div>
                        <div class="footer-hotline-number">{{ company_mobile }}</div>
                    </div>
                    <div class="footer-top-left-two" @click="toFeedBack()">
                        <div class="footer-hotline">
                            <img src="@/assets/images/index/icon_pen.png" alt="">
                        </div>
                        <div class="footer-hotline-text">意见反馈</div>
                    </div>
                </div>
                <div class="footer-top-middle">
                    <div class="middle-nav">
                        <div class="middle-nav-tit">
                            网址导航
                        </div>
                        <ul class="middle-nav-ul">
                            <li @click="toCharted()">我要包车</li>
                            <li @click="toOffer()">自动报价</li>
                            <li @click="toInfo()">文章资讯</li>
                            <li @click="toJoin()">司机入驻</li>
                        </ul>
                    </div>

                    <div class="middle-nav">
                        <div class="middle-nav-tit">
                            帮助中心
                        </div>
                        <ul class="middle-nav-ul">
                            <li @click="toHelp()">常见问题</li>
                            <li @click="toHelp()">更多帮助</li>
                            <li @click="toHelp(0)">隐私政策</li>
                            <li @click="toHelp(1)">服务协议</li>
                        </ul>
                    </div>

                    <div class="middle-nav">
                        <div class="middle-nav-tit">
                            关于保时达
                        </div>
                        <ul class="middle-nav-ul">
                            <li @click="toAboutUs()">关于我们</li>
                            <li @click="toHelpcenter()">维权与推广</li>
                        </ul>
                    </div>
                </div>
                <div class="footer-top-right">
                    <img class="footer-top-logo" :src="logo2" alt="">
                    <div class="footer-address">
                        地址：
                        <span>
                            <!--{{ address }}-->
                            福州仓山区城门镇福峡路1123号
                        </span>
                    </div>
                    <div class="footer-telephone">
                        电话：<span>{{ company_mobile }}</span>
                    </div>
                    <div class="footer-mail">
                        邮箱：<span>{{ email }}</span>
                    </div>
                </div>
            </div>
            <div class="footer-box-bot">
                <div class="footer-box-bot-top">
                    免责声明：本网站部分内容由用户自行上传，如权利人发现存在误传其作品情形，请及时与本站联系。
                </div>
                <div class="footer-box-bot-top">
                    闽公网安备41010402002065号
                    <a href="https://beian.miit.gov.cn/">
                        <!--{{ copyright }}-->
                        皇包车（厦门）科技集团有限公司福州分公司 闽ICP备20016057号-1
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "homeFooter",
        data() {
            return {
                logo: '',
                logo2: require('@/assets/images/index/index_bottom_logo.png'),
                address: '',
                company_mobile: '',
                email: '',
                copyright: '',
                app_qr_code: '',
            }
        },
        mounted() {
            this.getHomeWebSet();
        },
        methods: {
            getHomeWebSet() {
                this.$axios.get('/HomeWebSet', {}).then((res) => {
                    res = res.data;
                    if (res.status == 200) {
                        this.address = res.data.address;
                        this.app_qr_code = res.data.app_qr_code;
                        this.company_mobile = res.data.company_mobile;
                        this.copyright = res.data.copyright;
                        this.email = res.data.email;
                        this.logo = res.data.logo;
                    } else {
                        // layer.msg('系统错误，请刷新', {icon: 2});
                        this.$message.error('系统错误，请刷新');
                    }
                }).catch((error) => {
                    console.log(error);
                });
            },
            toFeedBack(){
                var currentUrl = this.$route.path;
                if (currentUrl.search('/feedback') != -1) {
                    return
                } else {
                    this.$router.push({name: 'FeedBack'});
                }
            },
            toCharted() {
                var currentUrl = this.$route.path;
                if (currentUrl.search('/charter') != -1) {
                    return
                } else {
                    this.$router.push({name: 'Charter'});
                }
            },
            toOffer() {
                var currentUrl = this.$route.path;
                if (currentUrl.search('/offer') != -1) {
                    return
                } else {
                    this.$router.push({name: 'Offer'});
                }
            },
            toInfo() {
                var currentUrl = this.$route.path;
                if (currentUrl.search('/information') != -1) {
                    return
                } else {
                    this.$router.push({name: 'Information'});
                }
            },
            toHelp(word){
                var currentUrl = this.$route.path;
                if (currentUrl.search('/helpcenter') != -1) {
                    return
                } else {
                    // this.$router.push({name: 'HelpCenter'});
                    this.$router.push({name: 'HelpCenter',params: { type: word}});
                }
            },
            toJoin(){
                var currentUrl = this.$route.path;
                if (currentUrl.search('/join') != -1) {
                    return
                } else {
                    this.$router.push({name: 'Join'});
                }
            },
            toAboutUs() {
                var currentUrl = this.$route.path;
                if (currentUrl.search('/about') != -1) {
                    return
                } else {
                    this.$router.push({name: 'About'});
                }
            },
            toHelpcenter(){
                this.$router.push({name: 'HelpCenter'});
            }
        }
    }
</script>

<style scoped>
    .home-footer {
        width: 100%;
        height: 320px;
        min-width: 1200px;
        background: #333;
        position: relative;
    }

    .home-footer-box {
        width: 1200px;
        margin: 0 auto;
    }

    .footer-box-top {
        width: 1200px;
        height: 168px;
        padding-top: 30px;
        padding-bottom: 20px;
        border-bottom: 1px solid #6c6c6c;
        overflow: hidden;
        /*display: flex;*/
        /*flex-direction: row;*/
        /*justify-content: space-between;*/
    }

    .footer-top-left {
        margin-left: 14px;
        width: 266px;
        float: left;
    }

    .footer-top-left-one {
        position: relative;
    }

    .footer-hotline {
        position: absolute;
        top: 0;
        left: 0;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background: #fff;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }

    .footer-hotline img {
        width: 15px;
        height: 15px;
    }

    .footer-hotline-text {
        height: 20px;
        line-height: 20px;
        color: #fff;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        margin-left: 30px;
    }

    .footer-hotline-number {
        height: 20px;
        line-height: 20px;
        color: #fff;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        margin-left: 30px;
        margin-top: 10px;
    }

    .footer-top-left-two {
        position: relative;
        margin-top: 20px;
        cursor: pointer;
    }

    .footer-top-middle {
        float: left;
        display: flex;
        flex-direction: row;
    }

    .middle-nav {
        width: 120px;
        display: flex;
        flex-direction: column;
    }

    .middle-nav-tit {
        height: 20px;
        line-height: 20px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #FFFFFF;
        margin-bottom: 10px;
    }

    .middle-nav-ul {
        display: flex;
        flex-direction: column;
    }

    .middle-nav-ul li {
        height: 26px;
        line-height: 26px;
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #FFFFFF;
        cursor: pointer;
    }

    .footer-top-right {
        float: right;
        width: 260px;
    }

    .footer-top-logo {
        width: 230px;
        height: 60px;
    }

    .footer-address {
        margin-top: 15px;
        color: #fff;
        line-height: 20px;
        font-size: 12px;
    }

    .footer-telephone {
        margin-top: 6px;
        color: #fff;
        line-height: 20px;
        font-size: 12px;
    }

    .footer-mail {
        margin-top: 6px;
        color: #fff;
        line-height: 20px;
        font-size: 12px;
    }

    .footer-box-bot {
        width: 1200px;
        height: 100px;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .footer-box-bot-top {
        width: 1200px;
        height: 20px;
        line-height: 20px;
        margin-top: 15px;
        font-size: 12px;
        text-align: center;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #959595;
    }

    .footer-box-bot-top a {
        color: #959595;
    }
</style>



// WEBPACK FOOTER //
// src/components/homeFooter.vue